<style>
.question {
  @apply text-xs;
  line-height: 1.67;
  letter-spacing: -0.29px;
}
.answer {
  @apply leading-7;
}
</style>

<script>
export let data = []
export let className = ""
</script>

<div class="wrapper {className}">
  {#each data as message}
    <div class="type-paragraph" class:mb-4="{message.authorRole !== 'doctor'}">
      {#if message}
        <span
          class:question="{message.authorRole === 'doctor'}"
          class:answer="{message.authorRole !== 'doctor'}"
          >{message.message}</span
        >
      {:else}--{/if}
    </div>
  {/each}
</div>
